import React from "react";
import TextField from "../../../../../Components/common/TextField/TextField";
import PasswordStrength from "../../../../../Components/common/PasswordStrength/PasswordStrength";
import CustomSelect from "../../../../../Components/common/CustomSelect/CustomSelect";
import { roleConstants } from "../../../../../utils/constants";

const ChangeFields = ({
  userName,
  setUserName,
  setRole,
  role,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  email = "",
  button = false,
  onCancel = null,
  error = null,
  roleData = roleConstants,
  roleDisabled = false,
}) => {
  return (
    <>
      <div className="flex flex-align-items-center">
        <div className="flex-column m-t-20 m-r-15">
          <p className="label">User Name</p>
          <TextField
            placeholder={"Type User Name"}
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />
        </div>
        <div className="flex-column m-t-20 m-l-15">
          <p className="label">Role</p>
          <CustomSelect
            width={"246px"}
            data={roleData}
            setSelected={setRole}
            select={role}
            height="40px"
            disabled={roleDisabled}
          />
        </div>
      </div>
      {/* Top-aligned rather than centred: the strength meter makes the password
          column taller, and centring would leave Confirm Password floating
          half-way down the row. */}
      <div className="flex">
        <div className="flex-column m-t-20 m-r-15">
          <p className="label">Create Password</p>
          <TextField
            placeholder={"Type Password"}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={error}
          />
          <PasswordStrength password={password} username={userName} email={email} />
        </div>
        <div className="flex-column m-t-20 m-l-15 relative">
          <p className="label">Confirm Password</p>
          <TextField
            placeholder={"Type Password"}
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={error}
          />
        </div>
      </div>
      <div className="flex flex-align-items-center m-t-20">
        {button && (
          <button className="users-accounts__update-button primary-button" onClick={button}>
            Update User
          </button>
        )}
        {onCancel && (
          <button className="users-accounts__update-cancel default-button" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
    </>
  );
};

export default ChangeFields;
